export {default, domains} from "./ui/src/components/modules/video-player-library/videoPlayerLibrary";
